import { Collapse, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelect, useDiagram } from "../../../hooks";
import { ObjectType } from "../../../data/constants";
import SearchBar from "./SearchBar";
import Empty from "../Empty";
import TableInfo from "./TableInfo";
import { useTranslation } from "react-i18next";
import emptyImage from "assets/svg/emptyImg.svg";
import EmptyComponent from "components/EmptyComponent";

export default function TablesTab() {
  const { tables, addTable } = useDiagram();
  const { selectedElement, setSelectedElement } = useSelect();
  const { t } = useTranslation();

  return (
    <div className="h-full flex flex-col">
      <div className="flex gap-2 mb-2">
        <SearchBar tables={tables} />
        <div>
          <Button icon={<PlusOutlined />} block onClick={() => addTable()}>
            添加表
          </Button>
        </div>
      </div>
      <div className="flex-1">
        {tables.length === 0 ? (
          // <Empty title={t("no_tables")} text={t("no_tables_text")} />
          <div className="h-full flex items-center justify-center">
            <EmptyComponent
              image={emptyImage}
              description="开始构建您的图表！"
            />
          </div>
        ) : (
          <Collapse
            activeKey={
              selectedElement.open &&
              selectedElement.element === ObjectType.TABLE
                ? `${selectedElement.id}`
                : ""
            }
            keepDOM
            lazyRender
            onChange={(k) =>
              setSelectedElement((prev) => ({
                ...prev,
                open: true,
                id: parseInt(k),
                element: ObjectType.TABLE,
              }))
            }
            accordion
          >
            {tables.map((t) => (
              <div id={`scroll_table_${t.id}`} key={t.id}>
                <Collapse.Panel
                  className="relative"
                  header={
                    <>
                      <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                        {t.name}
                      </div>
                      <div
                        className="w-1 h-full absolute top-0 left-0 bottom-0"
                        style={{ backgroundColor: t.color }}
                      />
                    </>
                  }
                  itemKey={`${t.id}`}
                >
                  <TableInfo data={t} />
                </Collapse.Panel>
              </div>
            ))}
          </Collapse>
        )}
      </div>
    </div>
  );
}
